import { PrismicSlice } from './prismic.response.interface';

export class SliceClass {
  public type: string;
  public label: string;
  public primary: unknown;
  public items: unknown[];
  public isHeadSlice = false;

  constructor(sliceData: PrismicSlice) {
    this.type = sliceData.slice_type;
    this.label = sliceData.slice_label;
  }
}
